export default (showId, networkId) => ({
  acastPlus: ['show', 'acastPlus', showId],
  show: networkId ? ['show', showId, networkId] : ['show', showId],
  showCheckRedirectFeed: (checkItunes) => [
    'show',
    'check-redirect',
    showId,
    checkItunes ? 'itunes' : 'import',
  ],
  coverColor: ['show', showId, 'cover-colors'],
  shows: (query) => (query ? ['shows', query] : ['shows']),
  networkAccessData: ['show', showId, 'owner-access'],
  supporters: ['show', showId, 'supporters'],
  waveform: (url) => ['show', showId, 'url', url],
});
